class LogoControl {
  onAdd(map) {
    this.map = map;
    this.container = document.createElement("div");
    this.container.className = "mapboxgl-ctrl";
    this.container.innerHTML = "<img src=\"/static/img/mashblock-nz.acc042b.svg\" alt=\"Mashblock NZ\" height=\"21\" />";
    this.toggle(false);
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }

  toggle(visibility) {
    this.container.style.display = (visibility) ? "unset" : "none";
  }

  getDefaultPosition() { // eslint-disable-line class-methods-use-this
    return "bottom-left";
  }
}

export default LogoControl;



// WEBPACK FOOTER //
// ./src/components/Map/logo_control.js